/* eslint-disable */
import Axios from 'axios'
// import axiosCancel from 'axios-cancel';

const { ConcurrencyManager } = require('axios-concurrency')

/*
 * Create a Api object with Axios and
 * configure it for the WordPRess Rest Api.
 *
 * The 'mynamespace' object is injected into the page
 * using the WordPress wp_localize_script function.
 */
const Api = Axios.create({
  baseURL: wpApiSettings.root,
  headers: {
    'content-type': 'application/json',
    'X-WP-Nonce': wpApiSettings.nonce
  }
})

// Possibilité d'annuler une requete en cours (package axios-cancel)
/*
axiosCancel(Api, {
  debug: false // default
})
*/

// a concurrency parameter of 1 makes all api requests secuential
const MAX_CONCURRENT_REQUESTS = 5

// init your manager.
const manager = ConcurrencyManager(Api, MAX_CONCURRENT_REQUESTS)

// to stop using the concurrency manager.
// will eject the request and response handlers from your instance
// manager.detach();

export default Api



// WEBPACK FOOTER //
// ./src/api/axios-api.js